export default function ToggleButton({
  value = false,
  onChange,
}: { value?: boolean; onChange: (on: boolean) => void }) {

  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      onClick={() => onChange(!value)}
      className={[
        "inline-flex h-7 w-12 items-center rounded-full transition-colors duration-200",
        value ? "bg-emerald-600" : "bg-gray-300",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500",
      ].join(" ")}
    >
      <span
        className={[
          "inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform duration-200",
          value ? "translate-x-6" : "translate-x-1",
        ].join(" ")}
      />
      <span className="sr-only text-white">{value ? "On" : "Off"}</span>
    </button>
  );
}